import React, { ReactNode } from 'react';
import NextLink, { LinkProps as NextLinkProps } from 'next/link';

export interface CoreLinkProps extends NextLinkProps {
  children: ReactNode;
  style?: Record<string, unknown>;
  target?: string;
  rel?: string;
  isActive?: (path: string) => boolean;
  absolute?: boolean;
  title?: string;
  className?: string;
  onClick?: (event: React.MouseEvent<Element, MouseEvent>) => void;
}

export const CoreLink = ({
  children,
  style,
  absolute = false,
  target,
  rel,
  href,
  className,
  onClick,
  ...props
}: CoreLinkProps) => {
  const anchorTag = (
    <a style={style} target={target} rel={rel} className={className} onClick={onClick}>
      {children}
    </a>
  );

  if (absolute) {
    return React.cloneElement(anchorTag, {
      href,
    });
  }

  return (
    <NextLink href={href} {...props}>
      {anchorTag}
    </NextLink>
  );
};
